import { REDUCE_PAYMENT_TRANSFER_RESULT_READ_ONLY } from '../../constants/actions/payment';

export function reducePaymentTransferResultReadOnly(payload) {
    return {
        type: REDUCE_PAYMENT_TRANSFER_RESULT_READ_ONLY,
        payload,
    };
}
